/* eslint-disable import/no-anonymous-default-export */
import { AutoComplete, Button, Checkbox, Collapse, DatePicker, Form, Input, InputNumber, notification, Select } from "antd";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import useCodigosInfraccionAPI, { CodigoInfraccion } from "../codigos-infraccion/hooks/useCodigosInfraccionAPI";
import useEtiquetas from "../codigos-infraccion/hooks/useEtiquetas";
import DataSave, { DataSaveRef } from "../common/components/DataSave";
import MainLayout from "../common/components/MainLayout";
import { ActionResult } from "../common/hooks/useApi";
import { PlusOutlined, MinusOutlined } from '@ant-design/icons'
import useUnidadesProduccionAPI, { UnidadProduccion } from "../unidades-produccion/useUnidadesProduccionAPI";
import useConfiguracionesProduccionAPI, { ConfiguracionProduccion, ConfiguracionProduccionForm, ConfiguracionProduccionSave, PlataformaPago, TipoContenedorPrecarga, TipoExportacion, TipoImpresion } from "./useConfiguracionesProduccionAPI";
import 'moment/locale/es-mx';
import locale from 'antd/es/date-picker/locale/es_ES'
import moment from "moment";
import _ from "lodash";
import Base64Upload from "../common/components/Base64Upload";
import useUtils from "../common/hooks/useUtils";
import TagInput from "../common/components/TagInput";

moment.updateLocale('es-mx', {
    week: {
        dow: 1
    },

});

const UploadContainer = styled.div`
  height: 100px;
  background: white;
  align-items: center;
  justify-content: center;
  display: flex;
  font-weight: 600;

  &::before {
    content: "";
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    /* width: calc(100% - 1rem); */
    /* height: calc(100% - 1rem); */
    border: 2px dashed;
    bottom: 0.5rem;
    right: 0.5rem;
  }

  input {
    z-index: 2;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
`;

const CotizacionUf = styled.div`
display:grid;
gap:0.5rem;
span
{
    display:flex;
    gap:0.5rem;
    align-items: end;
}
`;

export default () => {
    const { id } = useParams();
    const { getProvinciasList } = useUtils();
    const api = useConfiguracionesProduccionAPI();
    const unidadesProduccionApi = useUnidadesProduccionAPI();
    const successRoute = "/configuraciones-produccion"
    const codigosInfraccionApi = useCodigosInfraccionAPI();
    const [codigosInfraccionResponse, setCodigosInfraccionResponse] = useState<ActionResult<CodigoInfraccion[]>>();
    const [tiposContenedorPrecargaResponse, setTiposContenedorPrecargaResponse] = useState<ActionResult<TipoContenedorPrecarga[]>>();
    const [unidadesProduccionResponse, setUnidadesProduccionResponse] = useState<ActionResult<UnidadProduccion[]>>();
    const [configuracionProduccion, setConfiguracionProduccion] = useState<ConfiguracionProduccionForm>({
        ConfiguracionesFecha: [{}]
    });
    const { etiquetas } = useEtiquetas();
    const dataSaveRef = useRef<DataSaveRef<ConfiguracionProduccionForm>>(null!);
    const inputRef = useRef<HTMLInputElement>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [excluirPatentesBoolean, setExcluirPatentesBoolean] = useState<boolean>(false)

    const onChangeEtiquetaCodigoInfraccion = (etiqueta: string) => {
        dataSaveRef.current.form.resetFields(["CodigoInfraccionId"]);
        codigosInfraccionApi
            .list({ $top: 1000, $filter: [`Etiqueta eq '${etiqueta}'`] })
            .then(setCodigosInfraccionResponse);
    };

    const addConfiguracionFecha = () => {
        const newData = {
            ...configuracionProduccion,
            ...{
                ConfiguracionesFecha: [...configuracionProduccion.ConfiguracionesFecha!, ...[{ LimiteFecha: moment() }]]
            }
        };

        dataSaveRef.current.form.setFieldsValue(newData);
        setConfiguracionProduccion(newData);
    }

    const removeSegmentoUf = (index: number) => {
        const newConfiguracionesFecha = [...configuracionProduccion.ConfiguracionesFecha!];
        newConfiguracionesFecha.splice(index, 1);
        const newData = {
            ...configuracionProduccion,
            ...{
                ConfiguracionesFecha: newConfiguracionesFecha
            }
        };

        dataSaveRef.current.form.setFieldsValue(newData);
        setConfiguracionProduccion(newData)
    };

    const getConfiguracionesFecha = () => {
        return _.chain(configuracionProduccion.ConfiguracionesFecha)
            .map((c, index) => ({ ...c, ...{ id: index } }))
            .orderBy(c => c.LimiteFecha?.unix(), 'asc')
            .value();
    };

    const enmascararCuitCuilExcluidos = (data:string) => {
        if(!data) return;

        const value = data.split(',');
        const uniqueItems = Array.from(new Set(value.map((item: string) => {
            if(!item.includes('-')){
                let numStr = item.toString().trim();
            
                // Formatear el número usando substring
                let part1 = numStr.substring(0, 2);  // Primeros dos dígitos
                let part2 = numStr.substring(2, 10); // Los siguientes ocho dígitos
                let part3 = numStr.substring(10);    // Último dígito
                item = `${part1}-${part2}-${part3}`;
            }
            
            return item;
    }))).map(item => ({Nombre: item}))
        return uniqueItems;
    }

    useEffect(() => {
        api
            .listTiposContenedorPrecarga()
            .then(setTiposContenedorPrecargaResponse);

        unidadesProduccionApi
            .list({ $top: 10000 })
            .then(setUnidadesProduccionResponse);
    }, []);

    return (
        <MainLayout title="Guardar configuración de producción">
            <DataSave<ConfiguracionProduccion, ConfiguracionProduccionSave, ConfiguracionProduccionForm>
                list={(query) => api.list({ ...query, ...{ $expand: ['ConfiguracionesFecha'] } })}
                save={api.save}
                transformOnLoad={async (value) => ({
                     ...value, ...{
                        ConfiguracionesFecha: value.ConfiguracionesFecha.map((c) => ({ ...c, ...{ LimiteFecha: moment(c.LimiteFecha).year() == 0 ? undefined : moment(c.LimiteFecha) } })),
                        PatentesExcluidas: value.PatentesExcluidas?.split(',').map((c: string) => ({Nombre:c})),
                        CuitCuilExcluidos: enmascararCuitCuilExcluidos(value.CuitCuilExcluidos ?? '')//maparcuitcuilexcluidos(value.CuitCuilExcluidos?? '')
                    }})
                }
                transformOnSave={async (value) => ({ ...value, ...{
                     ConfiguracionesFecha: JSON.stringify(value.ConfiguracionesFecha),
                     PatentesExcluidas: value.PatentesExcluidas?.map(c => c.Nombre).join(','),
                     CuitCuilExcluidos: value.CuitCuilExcluidos?.map(c => c.Nombre.replace(/-/g,'')).join(',')
                    }})}
                id={id}
                successRoute={successRoute}
                onChange={(data) => setConfiguracionProduccion({ ...data, ...{ ConfiguracionesFecha: data.ConfiguracionesFecha ?? [{}] } })}
                onLoadedItem={async (item) => {onChangeEtiquetaCodigoInfraccion(item.EtiquetaCodigoInfracciones);/*setPatentesExluidas(item.PatentesExcluidas)*/}}
                ref={dataSaveRef}
            >
                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Nombre"}
                    label="Nombre"
                    help={"Puede indicar la fuente de las infracciones. Ej: \"Radar\""}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"UnidadProduccionId"}
                    label="Unidad de producción">
                    <Select
                        value
                        showSearch
                        optionFilterProp="children"
                        loading={!unidadesProduccionResponse}>
                        {unidadesProduccionResponse?.data?.value.map(u =>
                            <Select.Option value={u.Id}>{u.Nombre}</Select.Option>)}
                    </Select>
                </Form.Item>

                <Form.Item
                    name={"TipoImpresion"}
                    label="Tipo de impresión"
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                >
                    <Select
                        allowClear
                    >
                        <Select.Option value={"NO_IMPRIME" as TipoImpresion}>Sin impresión</Select.Option>
                        <Select.Option value={"ACTA_IMPORTADA" as TipoImpresion}>Acta importada</Select.Option>
                        <Select.Option value={"TEMPLATE" as TipoImpresion}>Plantilla</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name={"TipoExportacion"}
                    label="Tipo de exportación"
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                >
                    <Select
                        allowClear
                    >
                        <Select.Option value={"NO_EXPORTA" as TipoExportacion}>Sin exportación</Select.Option>
                        <Select.Option value={"PROTOCOLO_BA" as TipoExportacion}>Protocolo Buenos Aires</Select.Option>
                    </Select>
                </Form.Item>


                <Collapse accordion >
                    <Collapse.Panel forceRender header={"Datos SFTP para precarga"} key={"sftp_1"}>
                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            required
                            name={"SftpHost"}
                            label="Host SFTP">
                            <Input />
                        </Form.Item>

                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            required
                            name={"SftpPuerto"}
                            label="Puerto SFTP">
                            <Input />
                        </Form.Item>

                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            required
                            name={"SftpUsuario"}
                            label="Usuario SFTP">
                            <Input />
                        </Form.Item>

                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            required
                            name={"SftpContrasena"}
                            label="Contraseña SFTP">
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            required
                            name={"SftpRuta"}
                            label="Ruta SFTP">
                            <Input />
                        </Form.Item>
                    </Collapse.Panel>

                    <Collapse.Panel forceRender header="Datos del contenedor de las imágenes" key={"contenedor_1"}>
                        <Form.Item
                            label={"Tipo de contenedor"}
                            name="TipoContenedorPrecarga"
                        >
                            <Select
                                loading={!codigosInfraccionApi}
                                optionFilterProp="children"
                            >
                                {tiposContenedorPrecargaResponse?.data?.value.map(t => <Select.Option key={t.id} value={t.id}>{t.nombre}</Select.Option>)}
                            </Select>
                        </Form.Item>


                        <Form.Item
                            name={"ContrasenaContenedor"}
                            label="Contraseña del contenedor"
                            help={'Contraseña del contenedor de las imágenes (ej. el archivo .zip)'}
                        >
                            <Input.Password />
                        </Form.Item>

                    </Collapse.Panel>

                    <Collapse.Panel forceRender header="Datos del código de infracción" key={"tipo_infraccion_1"}>
                        <Form.Item
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}
                            required
                            name={"EtiquetaCodigoInfracciones"}
                            label="Etiqueta asociada al código de infracciones"
                        >

                            <Select
                                showSearch
                                optionFilterProp="children"
                                onChange={onChangeEtiquetaCodigoInfraccion}
                                allowClear
                            >
                                {etiquetas.map(e =>
                                    <Select.Option key={e.value} value={e.value}>
                                        {e.text}
                                    </Select.Option>)}
                            </Select>
                        </Form.Item>
                        <Form.Item

                            label={"Código de infracción"}
                            name="CodigoInfraccionId"
                        >
                            <Select
                                allowClear
                                disabled={!codigosInfraccionResponse}
                                showSearch
                                optionFilterProp="children"
                                onChange={(value) => {
                                    if (dataSaveRef.current.form.getFieldValue('CodigoInfraccionId') == undefined) {
                                        dataSaveRef.current.form.setFieldsValue({ 'CodigoInfraccionId': null })
                                    }
                                }}
                            >
                                {codigosInfraccionResponse?.data?.value.map(c =>
                                    <Select.Option key={c.Id} value={c.Id}>
                                        ({c.Etiqueta}) {c.Abreviatura ?? c.Descripcion}
                                    </Select.Option>)}
                            </Select>
                        </Form.Item>
                    </Collapse.Panel>


                    {configuracionProduccion?.TipoExportacion == 'PROTOCOLO_BA' &&
                        <Collapse.Panel forceRender header="Datos de la exportación BA" key={"exportacion_ba_1"}>
                            <Form.Item
                                rules={[
                                    { required: true, message: "Campo requerido" }
                                ]}
                                required
                                name={"NombreProveedorBA"}
                                label="Nombre del proveedor">
                                <Input />
                            </Form.Item>
                            <Form.Item
                                rules={[
                                    { required: true, message: "Campo requerido" }
                                ]}
                                required
                                name={"CodigoProveedorBA"}
                                label="Código proveedor">
                                <Input />
                            </Form.Item>
                            <Form.Item
                                rules={[
                                    { required: true, message: "Campo requerido" }
                                ]}
                                required
                                name={"CodigoJurisdiccionBA"}
                                label="Código jurisdicción">
                                <Input />
                            </Form.Item>
                            <Form.Item
                                rules={[
                                    { required: true, message: "Campo requerido" }
                                ]}
                                required
                                name={"CodigoPostalBA"}
                                label="Código postal">
                                <Input />
                            </Form.Item>
                            <Form.Item
                                rules={[
                                    { required: true, message: "Campo requerido" }
                                ]}
                                required
                                name={"AutoridadConstatacionBA"}
                                label="Autoridad de constatación">
                                <Input />
                            </Form.Item>
                            <Form.Item
                                rules={[
                                    { required: true, message: "Campo requerido" }
                                ]}
                                required
                                name={"NumeroExportacionInicioBA"}
                                label="Número de exportación inicial">
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                rules={[
                                    { required: true, message: "Campo requerido" }
                                ]}
                                required
                                name={"NumeroDiaExportacionInicioBA"}
                                label="Número de día inicial">
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                rules={[
                                    { required: true, message: "Campo requerido" }
                                ]}
                                required
                                name={"NumeroInfraccionExportacionInicioBA"}
                                label="Número de infracción inicial">
                                <InputNumber />
                            </Form.Item>

                        </Collapse.Panel>
                    }



                    {configuracionProduccion?.TipoImpresion == 'TEMPLATE' &&
                        <Collapse.Panel forceRender header="Datos para la generacion del acta" key={"acta_1"}>
                            <Form.Item
                                rules={[
                                    { required: true, message: "Campo requerido" }
                                ]}
                                required
                                name={"TemplateImpresion"}
                                label="Plantilla del acta"
                            >
                                <Input />
                            </Form.Item>


                            <Collapse style={{ marginBottom: 10 }}>
                                <Collapse.Panel header="Datos de la plantilla" forceRender key={'datos-acta'}>

                                    <Form.Item
                                        rules={[
                                            { required: true, message: "Campo requerido" }
                                        ]}
                                        required
                                        name={"PrefijoTramite"}
                                        label="Prefijo Nro Trámite"
                                    >
                                        <Input style={{ width: 'auto' }} />
                                    </Form.Item>
                                    <Form.Item
                                        name={"Logo"}
                                        label="Logo"
                                    >
                                        <Base64Upload />
                                    </Form.Item>
                                    <Form.Item
                                        name={"Titulo"}
                                        label="Título"
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        name={"Subtitulo"}
                                        label="Subtítulo"
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        name={"Direccion"}
                                        label="Dirección"
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name={"Telefono"}
                                        label="Telefono"
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name={"Horarios"}
                                        label="Horarios"
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        rules={[
                                            { type: 'email', message: 'Ingrese un email valido' }
                                        ]}
                                        name={"Email"}
                                        label="Email"
                                    >
                                        <Input type="email" />
                                    </Form.Item>

                                    <Form.Item
                                        name={"Ley"}
                                        label="Ley"
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name={"Ordenanza"}
                                        label="Ordenanza"
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name={"Municipio"}
                                        label="Municipio"
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name={"LeyendaFirma"}
                                        label="Leyenda firma"
                                    >
                                        <Input.TextArea />
                                    </Form.Item>

                                    <Form.Item
                                        name={"TextoMaximo"}
                                        label="Texto para medición máxima"
                                        help="Ej: Velocidad máxima"
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name={"TextoMedido"}
                                        label="Texto para medición"
                                        help="Ej: Velocidad medida"
                                    >
                                        <Input />
                                    </Form.Item>


                                    <Form.Item
                                        name={"TextoHomologacion"}
                                        label="Texto con datos de homologación"
                                    >
                                        <Input.TextArea />
                                    </Form.Item>

                                    <Form.Item
                                        name={"TextoInformacion"}
                                        label="Texto de información"
                                    >
                                        <Input.TextArea />
                                    </Form.Item>

                                    <Form.Item
                                        name={"TextoObjeto"}
                                        label="Texto objeto"
                                    >
                                        <Input.TextArea />
                                    </Form.Item>


                                    <Form.Item
                                        name={"TextoAdvertenciaPagoVoluntario"}
                                        label="Texto de advertencia de pago voluntario"
                                    >
                                        <Input.TextArea />
                                    </Form.Item>

                                    <Form.Item
                                        name={"BannerMediosPago"}
                                        label="Banner de medios de pago"
                                    >
                                        <Base64Upload />
                                    </Form.Item>

                                    <Form.Item
                                        name={"TextoCorreoRetornar"}
                                        label="Retornar a (correo)"
                                    >
                                        <Input />
                                    </Form.Item>


                                    <Form.Item
                                        name={"TextoCorreoRazonSocial"}
                                        label="Razón social (correo)"
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name={"PatronCodigoBarrasCorreo"}
                                        label="Patrón para el código de barras del correo"
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name={"ValorCostoEnvio"}
                                        label="Costo de envío"
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name={"LargoMinCodigoBarrasCorreo"}
                                        label="Largo minimo para el código de barras"
                                    >
                                        <Input disabled={configuracionProduccion?.PatronCodigoBarrasCorreo?.trim() ? false : true} />
                                    </Form.Item>


                                </Collapse.Panel>
                            </Collapse>



                            <Collapse style={{ marginBottom: 10 }}>
                                <Collapse.Panel header="Datos de la plataforma de pagos" forceRender key={'datos-plataforma-pagos'}>
                                    <Form.Item
                                        rules={[
                                            { required: true, message: "Campo requerido" }
                                        ]}
                                        required
                                        name={"PlataformaPago"}
                                        label="Plataforma de pago">
                                        <Select
                                        >
                                            <Select.Option value={"HELIPAGOS" as PlataformaPago}>Helipagos</Select.Option>
                                            <Select.Option value={"EPAGOS" as PlataformaPago}>EPagos</Select.Option>
                                            <Select.Option value={"PAGOTIC" as PlataformaPago}>Pagotic</Select.Option>
                                        </Select>
                                    </Form.Item>

                                    <Form.Item
                                        name={"PrefijoSolicitudPago"}
                                        label="Prefijo de la solicitud">
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        name={"DescripcionSolicPago"}
                                        label="Descripcion de la solicitud">
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        rules={[
                                            { required: true, message: "Campo requerido" }
                                        ]}
                                        required
                                        name={"UrlApi"}
                                        label="URL de la API">
                                        <Input />
                                    </Form.Item>

                                    {configuracionProduccion?.PlataformaPago == 'HELIPAGOS' &&
                                        <>
                                            <Form.Item
                                                rules={[
                                                    { required: true, message: "Campo requerido" }
                                                ]}
                                                required
                                                name={"BearerHelipagos"}
                                                label="Bearer Helipagos">
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                rules={[
                                                    { required: true, message: "Campo requerido" }
                                                ]}
                                                required
                                                name={"ApiKeyHelipagos"}
                                                label="Api Key Helipagos">
                                                <Input />
                                            </Form.Item>
                                        </>
                                    }

                                    {configuracionProduccion?.PlataformaPago == 'EPAGOS' &&
                                        <>
                                            <Form.Item
                                                name={"ImplementadorEPagos"}
                                                label="Implementador EPagos"
                                                normalize={(v,pv,av)=>v.toString()}
                                                >
                                                <InputNumber />
                                            </Form.Item>
                                            <Form.Item
                                                name={"TipoOperacionEpagos"}
                                                label="Tipo operacion EPagos">
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                rules={[
                                                    { required: true, message: "Campo requerido" }
                                                ]}
                                                required
                                                name={"IdOrganismoEpagos"}
                                                label="Id organismo EPagos">
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                rules={[
                                                    { required: true, message: "Campo requerido" }
                                                ]}
                                                required
                                                name={"IdUsuarioEpagos"}
                                                label="Id usuario EPagos">
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                rules={[
                                                    { required: true, message: "Campo requerido" }
                                                ]}
                                                required
                                                name={"HashEpagos"}
                                                label="Hash EPagos">
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                rules={[
                                                    { required: true, message: "Campo requerido" }
                                                ]}
                                                required
                                                name={"PasswordEpagos"}
                                                label="Password EPagos">
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                rules={[
                                                    { required: true, message: "Campo requerido" }
                                                ]}
                                                required
                                                name={"ConvenioEpagos"}
                                                label="Convenio EPagos">
                                                <Input />
                                            </Form.Item>
                                        </>
                                    }
                                </Collapse.Panel>
                            </Collapse>

                            <Collapse style={{ marginBottom: 10 }} accordion>
                                {getConfiguracionesFecha().map((configuracion, index) =>
                                    <Collapse.Panel forceRender key={index} header={configuracion.LimiteFecha ? `Configuración hasta el ${configuracion.LimiteFecha.format("DD/MM/YYYY")}` : `Configuración final`}>
                                        <CotizacionUf key={`config-${configuracion.id}`}>
                                            {index != getConfiguracionesFecha().length - 1 && (
                                                <>
                                                    <Form.Item
                                                        label="Fecha límite"
                                                        style={{ marginBottom: 0 }}
                                                        rules={[
                                                            { required: true, message: "Campo requerido" },
                                                        ]}
                                                        required
                                                        name={["ConfiguracionesFecha", configuracion.id, "LimiteFecha"]}
                                                    >
                                                        <DatePicker format={'DD/MM/YYYY'} style={{ width: "auto", marginBottom: 0 }} locale={locale} />
                                                    </Form.Item>

                                                    <Form.Item
                                                        name={[
                                                            "ConfiguracionesFecha",
                                                            configuracion.id,
                                                            "Provincia",
                                                        ]}
                                                        rules={[
                                                            { required: true, message: "Campo requerido" },
                                                        ]}
                                                        required
                                                        label="Provincia del titular"
                                                    >
                                                        <Select showSearch allowClear style={{ width: "170px", marginBottom: 0 }}>
                                                            {getProvinciasList().map((province, index) => (
                                                                <Select.Option key={index} value={province}>
                                                                    {province}
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>

                                                    <Form.Item
                                                        name={[
                                                            "ConfiguracionesFecha",
                                                            configuracion.id,
                                                            "CodigoPostal",
                                                        ]}
                                                        label="Codigo postal del titular"
                                                    >
                                                        <Input style={{ width: "100px", marginBottom: 0 }} />
                                                    </Form.Item>
                                                </>
                                            )
                                            }
                                            <Form.Item
                                                rules={[
                                                    { required: true, message: "Campo requerido" },
                                                ]}
                                                required
                                                label="Cotización de la UF"
                                                name={["ConfiguracionesFecha", configuracion.id, "CotizacionUF"]}
                                                style={{ marginBottom: 0 }}
                                            >
                                                <InputNumber style={{ width: "auto", marginBottom: 0 }} min={1} />
                                            </Form.Item>
                                            <Form.Item
                                                rules={[
                                                    { required: true, message: "Campo requerido" }
                                                ]}
                                                required
                                                name={["ConfiguracionesFecha", configuracion.id, "PorcentajeDescuentoPagoVoluntario"]}
                                                label="Descuento pago voluntario (%)"
                                                style={{ marginBottom: 0 }}
                                            >
                                                <InputNumber style={{ width: "auto" }} min={0} />
                                            </Form.Item>

                                            <Form.Item
                                                rules={[
                                                    { required: true, message: "Campo requerido" }

                                                ]}
                                                required
                                                style={{ marginBottom: 0 }}
                                                name={["ConfiguracionesFecha", configuracion.id, "DiasPagoVoluntario"]}
                                                label="Días para pago voluntario"
                                            >
                                                <InputNumber style={{ width: "auto" }} min={-1} />
                                            </Form.Item>

                                            <Form.Item
                                                rules={[
                                                    { required: true, message: "Campo requerido" }
                                                ]}
                                                help="Días desde culminado el primer vencimiento"
                                                style={{ marginBottom: 0 }}
                                                required
                                                name={["ConfiguracionesFecha", configuracion.id, "Dias2doVencimiento"]}
                                                label="Días para 2do vencimiento">
                                                <InputNumber style={{ width: "auto" }} min={1} />
                                            </Form.Item>

                                            <Form.Item
                                                help="Esto solo mostrara la cantidad de UF que equivale al monto administrativo."
                                                name={"CantidadUFGastosAdm"}
                                                label="Cantidad UF Gastos Adm."
                                            >
                                                <Input />
                                            </Form.Item>

                                            <Form.Item name={"UFVisibleMontos"} valuePropName="checked">
                                                <Checkbox style={{ marginTop: 10 }}>Mostrar cantidad de UF en los montos de la infracción</Checkbox>
                                            </Form.Item>

                                            <Form.Item name={"VencimientoExtendido"} valuePropName="checked">
                                                <Checkbox style={{ marginTop: 10 }}>Habilitar tolerancia de un dia en QR y Codigo de barras. (Recordar aumentar en uno los dias de vencimiento)</Checkbox>
                                            </Form.Item>

                                            <Form.Item
                                                name={["ConfiguracionesFecha", configuracion.id, "DiasDescargo"]}
                                                label="Días para descargo (texto del acta)"
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Input style={{ width: "100%" }} min={1} />
                                            </Form.Item>

                                            <Form.Item
                                                rules={[
                                                    { required: true, message: "Campo requerido" }
                                                ]}
                                                required
                                                name={["ConfiguracionesFecha", configuracion.id, "GastosAdministrativos"]}
                                                style={{ marginBottom: 0 }}
                                                label="Gastos administrativos">
                                                <InputNumber style={{ width: "100%" }} min={0} />
                                            </Form.Item>
                                            <span>
                                                <Button disabled={index == configuracionProduccion.ConfiguracionesFecha!.length - 1} onClick={() => removeSegmentoUf(configuracion.id)} type="primary" style={{ marginTop: '7px' }} icon={<MinusOutlined />} />
                                                <Button onClick={addConfiguracionFecha} type="primary" style={{ marginTop: '7px' }} icon={<PlusOutlined />} />
                                            </span>
                                        </CotizacionUf>
                                    </Collapse.Panel>
                                )}

                            </Collapse>

                        </Collapse.Panel>

                    }

                    <Collapse.Panel forceRender header="Configuraciones adicionales" key={"config_adicionales"}>

                        <b>Excluir por Patentes</b>
                        <Form.Item name={"ExcluirPatentes"} valuePropName="checked">
                            <Checkbox value={excluirPatentesBoolean} style={{ marginTop: 10 }} onChange={(e) => {
                                setExcluirPatentesBoolean(e.target.checked)
                            }}>Habilitar excluir por Patentes</Checkbox>
                        </Form.Item>

                        <Form.Item
                            name={"PatentesExcluidas"}
                            label="Ingresar patentes:"
                            rules={[{
                                required: false,
                                message: "Agregue una patente"

                            }]}
                            normalize={(value) => {
                                if (Array.isArray(value)) {
                                    const uniqueItems = Array.from(new Set(value.map(item => item.Nombre.toUpperCase())))
                                        .map(name => ({ Nombre: name }));
                                    return uniqueItems;
                                }
                                return value;
                            }}
                        >
                            <TagInput textButton="Patente"/>

                        </Form.Item>

                        <b>Excluir por CUIT/CUIL</b>
                        <Form.Item name={"ExcluirCuitCuil"} valuePropName="checked">
                            <Checkbox>Habilitar excluir por CUIT/CUIL</Checkbox>
                        </Form.Item>

                        <Form.Item
                            name={"CuitCuilExcluidos"}
                            label="Ingresar CUIT/CUIL:"
                            rules={[{
                                required: false,
                                message: "Agregue una patente"
                            }]}

                            normalize={(value) => {
                               if(Array.isArray(value)){
                                return enmascararCuitCuilExcluidos(value.map((x: { Nombre: string; }) => x.Nombre).join(','))
                               }
                            }}
                        >
                            <TagInput textButton="CUIT/CUILS"/>
                        </Form.Item>
                    </Collapse.Panel>

                </Collapse>

            </DataSave>
        </MainLayout>
    );
};